export const ResumeViewer = () => {
    const pdfPath = `${process.env.PUBLIC_URL || ""}/Lisa_Cho_Resume.pdf`;

    return (
        <div className="pdf-viewer">
            <iframe 
                src={pdfPath}
                title="Resume"
                style={{ 
                    width: "100%", 
                    height: "80vh", 
                    border: "none"
                }}
            />
        </div>
    );
};